import { theme } from "themes/default/theme"

export const styles = {
  modalContainer: {
    ...theme.mixins.modalContent,
    overflow: "visible",
    p: 0,
    m: 0,
    minHeight: 0,
    maxWidth: 800,
  },
  title: (theme) => ({
    textAlign: "center",
    color: theme.palette.common.black,
    fontSize: 27,
  }),
  modalContent: {
    p: 0,
    py: 3.75,
  },
  alertMessage: (theme) => ({
    borderRadius: 0,
    color:
      theme.palette.mode === "dark"
        ? theme.palette.common.black
        : theme.palette.common.white,
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.success.secondary,
  }),
  cancelButton: {
    textTransform: "none",
    minWidth: "25%",
  },
  gamesItemContainer: {
    flexWrap: "wrap",
  },
  footerButtons: (theme) => ({
    px: 3.75,
    backgroundColor: theme.palette.background.default,
  }),
  mainImage: {
    width: "75px!important",
    height: "75px!important",
    position: "absolute!important",
    zIndex: 1,
    top: -35,
    left: "50%",
    transform: "translateX(-50%)",
  },
  gamesItemContainerMax: {
    margin: "0 auto",
    maxWidth: 600,
    alignItems: "stretch",
    "& > div": {
      minWidth: 170,
    },
  },
}
